<div style="display: block;">
  <canvas mdbChart *ngIf="refreshScope" id="myChart"
          [chartType]="chartType"
          [datasets]="chartDatasets"
          [labels]="chartLabels"
          [colors]="chartColors"
          [options]="chartOptions"
          [legend]="true">
  </canvas>
</div>
<div style="position: absolute;bottom: 2px;right: 10px;">
  <a (click)="clear()" class="btn btn-sm btn-success" style=" border-radius: 1rem">
    <i class="fa fa-redo fa-xs"></i>
  </a>
</div>
